const Select = (props) => {

    let { campo, idComponente, select } = props;

    let filtros = {
        campos: [
            "matricula_regimental",
            "matricula_nao_regimental",
            "matricula_pago",
            "hora_regimental",
            "hora_nao_regimental",
            "hora_pago",
        ],
        visao: [
            "mensal",
            "acumulado"
        ]
    }

    let campoExtenso = [
        "Matrícula (Regimental)",
        "Matrícula (Não Regimental)",
        "Matrícula (Pago)",
        "Hora (Regimental)",
        "Hora (Não Regimental)",
        "Hora (Pago)",
    ];

    let nomeCampo = campo;
    campo = filtros[campo];

    return (
        <>
        <form>
            <div className="form-group">
                <label className="text-capitalize">{nomeCampo || "campos"}: </label>
                <select name="select" onChange={select} className="form-control" id={idComponente || "selectCampo"}>
                    {campo.map((modalidade, i) => {
                        return(
                            <option value={modalidade}>{nomeCampo === "campos" ? campoExtenso[i] : modalidade }</option>
                        )
                    })}
                </select>
            </div>
        </form>
        </>
    )

}

export default Select;